export class SkillCerts {
  SkillCate;
  Item;
  Seq;
  CDesc;
  EDesc;
  AnsType;
  OptValue;
  DatePerReq;
  constructor() {
    this.SkillCate = "";
    this.Item = "";
    this.Seq = "";
    this.CDesc = "";
    this.EDesc = "";
    this.AnsType = "";
    this.OptValue = "";
    this.DatePerReq = false;
  }
}



// WEBPACK FOOTER //
// ./src/model/SkillCerts.js